export const memoryStore = () => {
    const store = new Map<string, string>();
    return {
        "getItem": (key: string) => store.get(key),
        "setItem": (key: string, value: string) => store.set(key, value),
    };
};
